import { render, staticRenderFns } from "./DocumentationTabs.vue?vue&type=template&id=489b9a9a&scoped=true"
import script from "./DocumentationTabs.vue?vue&type=script&lang=ts"
export * from "./DocumentationTabs.vue?vue&type=script&lang=ts"
import style0 from "./DocumentationTabs.vue?vue&type=style&index=0&id=489b9a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b9a9a",
  null
  
)

export default component.exports